import { Col, Layout, Row } from 'antd'
import { STORAGE_TOKEN_KEY } from 'configs/constant'
import { useAppSelector } from 'hooks'
import LoginPage from 'pages/login/Login'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'
import FooterPC from './components/footer/FooterPC'
import HeaderPC from './components/header/HeaderPC'
import SidePC from './components/sidebar/SidePC'
interface Props {
  children: React.ReactNode
}
const HomeLayout: React.FC<Props> = ({ children }) => {
  const { Content } = Layout
  const { app } = useParams()
  const { app_id, setting } = useAppSelector((s) => s.app)

  if (!!app && app !== app_id) {
    localStorage.removeItem(STORAGE_TOKEN_KEY)
    return <LoginPage />
  }

  // useEffect(() => {
  //   const updateSize = () => {
  //     const width = window.innerWidth
  //     ;(document.body.style as any).zoom = `calc(${(+width / 1920) * 100}%)`
  //   }

  //   window.addEventListener('resize', updateSize)
  //   updateSize()

  //   return () => {
  //     window.removeEventListener('resize', updateSize)
  //   }
  // }, [])

  return (
    <Layout style={{ background: '#fff' }}>
      <Helmet>
        <title>{setting?.app_name}</title>
      </Helmet>
      <HeaderPC />
      <Layout className="home-container" hasSider={true}>
        <Row style={{ width: '100%' }}>
          <Col xs={8} sm={11} md={8} xl={5}>
            <SidePC />
          </Col>
          <Col xs={16} sm={13} md={16} xl={19}>
            <Content>{children}</Content>
          </Col>
        </Row>
      </Layout>
      <FooterPC />
    </Layout>
  )
}

export default HomeLayout
